module.exports = __webpack_public_path__ + "static/media/CTLI_8-111w.28fc3947.webp";